import React from "react";
import { Box } from "@chakra-ui/react";
import { Navigate, Route, Routes } from "react-router-dom";
import routes from "routes";

export default function AuthLayout() {
  const getRoutes = () => {
    return routes
      .filter((route) => route.layout === "/auth")
      .map((route, index) => (
        <Route
          key={index}
          path={route.path}
          element={route.element}
        />
      ));
  };

  return (

      <Box w="100%">
        <Routes>
          {getRoutes()}
          <Route path="*" element={<Navigate to="/auth/login" replace />} />
        </Routes>
      </Box>
 
  );
}
